export default __webpack_public_path__ + "static/media/DSCN1672.c671df58.JPG";